/* global localStorage */
// TODO: Tech debt - needs refactoring, mainly copied from V1 but changed to IDs
// If we want to speed up the Mobile PDP by repeating elements in the page then change back to classes!
// In V1 we just had 2 listing_info sections on the page shown/hidden depending on breakpoint
// and this needed to work based on classes becasue of it
import { getFetchWrapper } from './fetchHelpers'
import { getLocaleFromPath } from '../utils/localeHelpers'

export default function initDeliverySection () {
  if (document.getElementById('vjs-fixed-delivery-container')) return
  if (!document.getElementById('vjs-delivery-select')) return
  preSelectDeliveryPrice()

  const deliverySelect = document.getElementById('vjs-delivery-select')
  deliverySelect.addEventListener('click', () => showDeliveryPrice(true))
}

function showDeliveryPrice (shouldChange) {
  // In V2, we could actually add a small data structure to the page and use
  // with this instead of depending on extra requests...
  getFetchWrapper(deliveryPriceUrl()).then((response) => response.json()).then((data) => {
    const priceToDisplay = data.value_to_display
    const gbpPrice = data.price_in_gbp

    const deliverySelect = document.getElementById('vjs-delivery-select')
    const selectedLocationValue = deliverySelect.options[deliverySelect.selectedIndex].value

    if (shouldChange) {
      localStorage.setItem('SelectedLocationIndex', deliverySelect.selectedIndex)
    }

    const deliveryPriceInGbp = priceToDisplay === 'Request a quote' ? null : gbpPrice
    updateCartItemLocation(selectedLocationValue, deliveryPriceInGbp)

    displayDeliveryPrice(selectedLocationValue, priceToDisplay)
  }).catch((error) => console.log(error))
}

function deliveryPriceUrl () {
  const location = document.getElementById('vjs-delivery-select').value
  const listingIdElement = document.querySelector('[data-id="content-listing-id"]')
  if (!location || !listingIdElement) return
  const listingId = listingIdElement.innerHTML
  return '/delivery_prices/' + listingId + '/price_by_location/' + location
}

function updateCartItemLocation (location, amount) {
  const deliveryLocation = document.getElementById('vjs-cart-delivery-location')
  const deliveryPrice = document.getElementById('vjs-cart-delivery-price')
  const itemIsOutOfCart = Boolean(deliveryLocation && deliveryPrice)

  if (itemIsOutOfCart) {
    deliveryLocation.value = location
    deliveryPrice.value = amount
  }
}

// not sure about this one
function noSetDeliveryPrice () {
  hideClassificationTag()

  const price = document.getElementById('vjs-delivery-section_price')
  const estimate = document.getElementById('vjs-uk-estimate-amount')
  const disclaimer = document.getElementById('vjs-estimate-disclaimer')
  const notAvailablePrice = document.getElementById('vjs-delivery-section_price-not-available')
  const notAvailableDisclaimer = document.getElementById('vjs-not-available-disclaimer')

  if (price) price.style.display = 'none'
  if (estimate) estimate.style.display = 'none'
  if (disclaimer) disclaimer.style.display = 'none'
  if (notAvailablePrice) notAvailablePrice.style.display = 'inline'
  if (notAvailableDisclaimer) notAvailableDisclaimer.style.display = 'block'
}

function showUkEstimate () {
  showEstimatedTag()

  const notAvailablePrice = document.getElementById('vjs-delivery-section_price-not-available')
  const price = document.getElementById('vjs-delivery-section_price')
  const notAvailableDisclaimer = document.getElementById('vjs-not-available-disclaimer')
  const estimate = document.getElementById('vjs-uk-estimate-amount')
  const disclaimer = document.getElementById('vjs-estimate-disclaimer')

  if (notAvailablePrice) notAvailablePrice.style.display = 'none'
  if (price) price.style.display = 'none'
  if (notAvailableDisclaimer) notAvailableDisclaimer.style.display = 'none'
  if (estimate) estimate.style.display = 'inline'
  if (disclaimer) disclaimer.style.display = 'block'
}

function displayFreeDelivery () {
  showFreeTag()

  const notAvailablePrice = document.getElementById('vjs-delivery-section_price-not-available')
  const estimate = document.getElementById('vjs-uk-estimate-amount')
  const notAvailableDisclaimer = document.getElementById('vjs-not-available-disclaimer')
  const price = document.getElementById('vjs-delivery-section_price')
  const disclaimer = document.getElementById('vjs-estimate-disclaimer')

  if (notAvailablePrice) notAvailablePrice.style.display = 'none'
  if (estimate) estimate.style.display = 'none'
  if (notAvailableDisclaimer) notAvailableDisclaimer.style.display = 'none'
  if (price) {
    price.style.display = 'inline'
    price.textContent = '£0'
  }
  if (disclaimer) disclaimer.style.display = 'block'
}

function displayPrice (value) {
  showEstimatedTag()

  const notAvailablePrice = document.getElementById('vjs-delivery-section_price-not-available')
  const estimate = document.getElementById('vjs-uk-estimate-amount')
  const notAvailableDisclaimer = document.getElementById('vjs-not-available-disclaimer')
  const price = document.getElementById('vjs-delivery-section_price')
  const disclaimer = document.getElementById('vjs-estimate-disclaimer')

  if (notAvailablePrice) notAvailablePrice.style.display = 'none'
  if (estimate) estimate.style.display = 'none'
  if (notAvailableDisclaimer) notAvailableDisclaimer.style.display = 'none'
  if (disclaimer) disclaimer.style.display = 'block'

  if (price) {
    price.style.display = 'inline'
    if (value.endsWith('.00')) {
      // Make it nicer by trimming cents
      price.textContent = value.slice(0, -3)
    } else {
      price.textContent = value
    }
  }
}

function displayRequestAQuote (selectedLocation) {
  noSetDeliveryPrice()
  if (selectedLocation.includes('United Kingdom') && selectedLocation !== 'United Kingdom - Northern Ireland') {
    showUkEstimate()
  }
}

function showEstimatedTag () {
  const disclaimer = document.getElementById('vjs-uk-delivery-estimate')
  if (disclaimer) {
    disclaimer.classList.remove('hidden')
    disclaimer.classList.remove('vsd-badge__success')
    disclaimer.classList.add('vsd-badge__warning')
    disclaimer.textContent = 'Estimated'
  }
}

function showFreeTag () {
  const disclaimer = document.getElementById('vjs-uk-delivery-estimate')
  if (disclaimer) {
    disclaimer.classList.remove('hidden')
    disclaimer.classList.add('vsd-badge__success')
    disclaimer.classList.remove('vsd-badge__warning')
    disclaimer.textContent = 'Free'
  }
}

function hideClassificationTag () {
  const disclaimer = document.getElementById('vjs-uk-delivery-estimate')
  disclaimer.classList.remove('vsd-badge__success')
  disclaimer.classList.remove('vsd-badge__warning')
  disclaimer.classList.add('hidden')
}

function displayDeliveryPrice (selectedLocation, deliveryPrice) {
  if (!deliveryPrice || deliveryPrice === 'Request a quote') {
    displayRequestAQuote(selectedLocation)
  } else if (deliveryPrice === 'Free') {
    displayFreeDelivery()
  } else {
    displayPrice(deliveryPrice)
  }
}

function preSelectDeliveryPrice () {
  let sessionSelectedLocation = localStorage.getItem('SelectedLocationIndex')
  const locale = getLocaleFromPath(window.location.pathname)
  // On a non-default locale, default the delivery destination to that locale's
  // country (from the Locale registry via <body data-locale-delivery-location>)
  // when the buyer hasn't chosen one yet.
  if (sessionSelectedLocation === null && locale !== null) {
    const localeLocationIndex = localeDefaultDeliveryLocationIndex()
    if (localeLocationIndex !== null) {
      localStorage.setItem('SelectedLocationIndex', localeLocationIndex)
      sessionSelectedLocation = localeLocationIndex
    }
  }

  if (sessionSelectedLocation !== null) {
    const deliverySelect = document.getElementById('vjs-delivery-select')
    deliverySelect.selectedIndex = sessionSelectedLocation
    deliverySelect.click()
  }
  showDeliveryPrice(false)
}

// Index of the <option> matching the current locale's default delivery location,
// or null if there's no such option. Matches on the option value (the English
// location key, e.g. 'Netherlands'), so it's locale-agnostic.
function localeDefaultDeliveryLocationIndex () {
  const location = document.body?.dataset?.localeDeliveryLocation
  if (!location) return null
  const select = document.getElementById('vjs-delivery-select')
  if (!select) return null
  const option = Array.from(select.options).find((o) => o.value === location)
  return option ? String(option.index) : null
}
